import { Injectable,Injector } from '@angular/core';
import  { createCustomElement, NgElement, WithProperties } from '@angular/elements';

// litmus components
import { LitmusInputComponent } from './litmus-input/litmus-input.component';
import { LitmusAttatchmentComponent } from './litmus-attatchment/litmus-attatchment.component';
import { LitmusDropdownComponent } from './litmus-dropdown/litmus-dropdown.component';
import { LtmsDatetimePickerComponent } from './ltms-datetime-picker/ltms-datetime-picker.component';
import { LitmusSearchComponent } from './litmus-search/litmus-search.component';
import { LitmusLabelComponent } from './litmus-label/litmus-label.component';
import { LitmusSeperatorComponent } from './litmus-seperator/litmus-seperator.component';
import { LitmusButtonComponent } from './litmus-button/litmus-button.component';
import { LitmusHeaderComponent } from './litmus-header/litmus-header.component';
import { LitmusLinkComponent } from './litmus-link/litmus-link.component';
import { LitmusListViewerComponent } from './litmus-list-viewer/litmus-list-viewer.component';

declare global {
  interface HTMLElementTagNameMap {
    'litmus-dropdown': NgElement & WithProperties<{props: any}>;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LitmusComponentsService {
  litmusComponents:any=[{
    selector:'litmus-input',
    component:LitmusInputComponent
  },{
    selector:'litmus-attatchment',
    component:LitmusAttatchmentComponent
  },{
    selector:'litmus-dropdown',
    component:LitmusDropdownComponent
  },{
    selector:'litmus-datetime-picker',
    component:LtmsDatetimePickerComponent
  },{
    selector:'litmus-search',
    component:LitmusSearchComponent
  },{
    selector:'litmus-label',
    component:LitmusLabelComponent
  },{
    selector:'litmus-seperator',
    component:LitmusSeperatorComponent
  },{
    selector:'litmus-button',
    component:LitmusButtonComponent
  },{
    selector:'litmus-header',
    component:LitmusHeaderComponent
  },{
    selector:'litmus-link',
    component:LitmusLinkComponent
  },{
    selector:'litmus-list-viewer',
    component:LitmusListViewerComponent
  }]
  constructor(private injector: Injector) { }
  registerComponents(){
    for(let component of this.litmusComponents){
      const element = createCustomElement(component.component, { injector:this.injector });
      customElements.define(component.selector, element);
    }
  }

}
